import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../Componentes/Card';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 2rem 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  flex-direction: row;
  width: 100vw;
  max-width: 100vw;
  box-sizing: border-box;
  align-items: center; /* Centra verticalmente el Card */

  @media (max-width: 900px) {
    gap: 1.2rem;
    padding: 2rem 0.3rem;
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 1.5rem;
    padding: 1.4rem 0.2rem;
  }
`;

const Column = styled.div`
  flex: 1 1 45%;
  min-width: 0; /* Evita overflow en flex */

  @media (max-width: 1200px) {
    flex: 1 1 100%;
    min-width: 0;
  }
  @media (max-width: 768px) {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
  }
`;

const AboutText = styled.div`
  width: 94%;
  max-width: 600px;
  margin: 0 auto;

  h2 {
    text-align: center;
    margin-bottom: 1rem;
    font-size: clamp(1.7rem, 4vw, 2.3rem);
  }

  p {
    line-height: 1.6;
    font-size: clamp(1.8rem, 2.8vw, 1.15rem);
    word-break: break-word;
  }
`;

const ReferenceToggle = styled.div`
  margin-top: 1rem;
  cursor: pointer;
  color: #0077cc;
  font-weight: bold;
  transition: all 0.3s ease;
  width: fit-content;

  &:hover {
    color: #005fa3;
    text-decoration: underline;
  }

  p {
    margin: 0;
    font-size: clamp(1rem, 2.5vw, 1.08rem);
  }
`;

const ReferenceBox = styled.div`
  margin-top: 1rem;
  background-color: #f9f9f9;
  padding: 1rem;
  border-left: 3px solid #0077cc;
  animation: fadeIn 0.4s ease-in-out;
  font-size: clamp(0.98rem, 2vw, 1.08rem);

  ul {
    margin: 0;
    padding-left: 1.2rem;
  }

  li {
    margin-bottom: 0.5rem;
    line-height: 1.5;
    word-break: break-word;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const About = ({ data }) => {
  const [showRefs, setShowRefs] = useState(false);
  const { t } = useTranslation();

  const toggleRefs = () => setShowRefs(!showRefs);

  return (
    <AboutSection id="about">
      <Column>
        <Card />
      </Column>
      <Column>
        <AboutText>
          <h2>Lab-DEMOSS</h2>
          <p>{t('about.proyecto')}</p>
          <p>{t('about.proyecto2')}</p>
        </AboutText>
      </Column>
    </AboutSection>
  );
};
